import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { redemptionReversalAPI } from 'api/icash'
import { MerchantLookupTypes } from 'types/merchanTxTypes'
import {
  IcashRedemptionReversalTxFormTypes,
  IcashRedemptionReversalTxFormSubmitValuesTypes,
  IcashRedemptionReversalTxFormSubmitActionsTypes,
} from 'types/icashRedemptionReversalTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

import { isGenericClient, isWFClient, isWWClient } from 'setups/controller'
import { projectClient } from 'constants/project'

const LOYALTYREDEMPTIONTXINITVAL: IcashRedemptionReversalTxFormTypes = {
  externalTransactionId: '',
  ident: '',
  storeId: 0,
  cashier: '',
  comments: '',
  traceNumber: 0,
  reasonId: 0,
  pin: ''
}

export const useIcashRedemptionReversalTx = (
  traderId: number,
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  isLoading: boolean
  initialValues: IcashRedemptionReversalTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleSubmitIcashRedemptionReversalTx: (
    values: IcashRedemptionReversalTxFormSubmitValuesTypes,
    actions: IcashRedemptionReversalTxFormSubmitActionsTypes
  ) => void
  handleClearIcashRedemptionReversalTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const [purchaseTxMerchant, purchaseTxMerchantSet] = useState<
    MerchantLookupTypes[]
  >([])
  const member = useMemberStore((state) => state.member)
  const [initialValues, initialValuesSet] =
    useState<IcashRedemptionReversalTxFormTypes>({
      ...LOYALTYREDEMPTIONTXINITVAL,
      cashier: authTokenUsername,
      externalTransactionId: '',
      ...((isGenericClient(projectClient) || isWFClient(projectClient) || isWWClient(projectClient)) && {
        ident: String(member?.cardNumber) || '',
      }),
    })

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleSubmitIcashRedemptionReversalTx = useCallback(
    async (
      values: IcashRedemptionReversalTxFormSubmitValuesTypes,
      actions: IcashRedemptionReversalTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        await redemptionReversalAPI(values)
        toast.success('iCash redemption reversal successful.')
        onCloseModal()
        // actions.setSubmitting(false)
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearIcashRedemptionReversalTx = useCallback(() => {
    initialValuesSet({ ...LOYALTYREDEMPTIONTXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleSubmitIcashRedemptionReversalTx,
    handleClearIcashRedemptionReversalTx,
  }
}
